<ng-container *ngIf="newRecipientModel.currentStep === addBeneficiaryStep.STEP1">
    <np-add-new-recipient-step-1 [action]="action"></np-add-new-recipient-step-1>
</ng-container>

<ng-container *ngIf="newRecipientModel.currentStep === addBeneficiaryStep.STEP2">
    <np-add-new-recipient-step-2 [action]="action" [remitterRequired]="remitterRequired" [beneficiarySource]="beneficiarySource"></np-add-new-recipient-step-2>
</ng-container>

<ng-container *ngIf="newRecipientModel.currentStep === addBeneficiaryStep.STEP3">
    <np-step-three></np-step-three>
</ng-container>

<ng-container *ngIf="newRecipientModel.currentStep === addBeneficiaryStep.Authy">
    <np-add-new-recipient-verify-code [action]="action" [remitterRequired]="remitterRequired" [beneficiarySource]="beneficiarySource"></np-add-new-recipient-verify-code>
</ng-container>
